import { render, staticRenderFns } from "./InternalSubscriptions.vue?vue&type=template&id=5c36d627"
import script from "./InternalSubscriptions.vue?vue&type=script&lang=js"
export * from "./InternalSubscriptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports